import { React } from 'react'
import styles from './TrendCharts.module.scss'
import ModelTabs from './ModelTabs'
import AllergyAqiLineChartCompare from './AllergyAqiLineChartCompare'
const TrendCharts = ({ chartData,dataCategory,geo_parent,geo_type, geo_id, 
  data_type, pollutantChartData,pollenChartData,dataCategoryPollen,dataCategoryPollutant}) => {    

  if(geo_type==='ZIP3')
  {
    var geotype= (geo_type==='ZIP3' && geo_id ===undefined) ? "STATE": 'zip3'
    geo_id = (geo_type==='ZIP3' && geo_id ===undefined) ? geo_parent:geo_id
    geo_type = geotype
  }

 
  return  (
    <>
    <div className={styles.base}>
    <div className={styles.containerPanel}>

      {geo_type.toUpperCase()==='ZIP3'&& 
      <>
        <ModelTabs  
          pollutantChartData={pollutantChartData}
          pollenChartData={pollenChartData}
          dataCategoryPollen={dataCategoryPollen}
          dataCategoryPollutant={dataCategoryPollutant}
          geo_parent={geo_parent}
          geo_type={geo_type} 
          geo_id={geo_id} 
          data_type= {data_type} />
           
        {chartData!==null?<AllergyAqiLineChartCompare
            chartData={chartData}
            dataCategory={dataCategory}
           
      />:
      <div>Data Not Available</div>}    
        </> 
      }
     
      </div>
    </div>
    </>
  ) 
}

export default TrendCharts
